requirejs.config({
    baseUrl: '/v2/js/user_public/app',
    paths: {
        'bootstrap': '../../../lib/bootstrap/js/bootstrap.min',
        'marionette': '../../../lib/marionette/backbone.marionette',
        'backbone': '../../../lib/marionette/backbone',
        'underscore': '../../../lib/marionette/underscore',
        'jquery': '../../../lib/jquery/jquery.min',
        'pwa': '../../../lib/pwa',
        'jquery.cookie': '../../../lib/jquery.cookie',
        'cookieblock': '../../cookieblock',
        'jquery.ui': '../../../lib/jquery-ui-custom/jquery-ui.min',
        'jquery.ui.slider': '../../../lib/jquery-ui-custom/jquery-ui-slider',
        'jquery.ui.touch': '../../../lib/jquery-ui/jquery-ui-touch.amd',
        'handlebars': '../../../lib/marionette/handlebars',
        'marionette.handlebars': '../../../lib/marionette/backbone.marionette.handlebars',
        'utils.string': '../../string',
        'utils.locale': '../../locale',
        'utils.date': '../../date',
        'utils.time': '../../time',
        'less': '../../../lib/less.min',
        'ofi': '../../../lib/ofi.min',
        'bowser': '../../../lib/es5',
        'notification': '../../../js/push-notifications/push-notifications',
        'promise': '../../../lib/es6-promise.auto.min',
        'assign': '../../../lib/es6-object-assign',
        // external scripts
        'google_adwords': 'https://www.googleadservices.com/pagead/conversion_async',
        'google_analytic': 'https://www.google-analytics.com/analytics',
        'google_translate': 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit',
        'google_universal_analytic': 'https://www.googletagmanager.com/gtag/js?id=',
        'line_liff': 'https://static.line-scdn.net/liff/edge/2/sdk',
       // 'google.intl.phone': '../../../lib/intl-tel-input/js/utils',
        'google.intl.phone.init': '../../../lib/intl-tel-input/js/intl.initializer',
    },
    deps: [
        'marionette.handlebars', 'view/helper/TemplateHelper', 'view/helper/TemplatePartials', 'jquery', 'pwa', 'jquery.cookie', 'jquery.ui', 'jquery.ui.slider', 'jquery.ui.touch',
        'utils.locale', 'utils.date', 'utils.time', 'bootstrap', 'notification', 'ofi', 'bowser', 'promise', 'assign', /*'google.intl.phone',*/ 'google.intl.phone.init'
    ],
    shim: {
        'view/helper/TemplatePartials': ['jquery'],
        'bootstrap': ['jquery'],
        'pwa': ['jquery'],
        'notification': ['jquery'],
        'jquery.cookie': ['jquery'],
        'cookieblock': ['jquery.cookie'],
        'jquery.ui': {
            'deps': ['jquery']
        },
        'jquery.ui.slider': {
            'deps': ['jquery', 'jquery.ui']
        },
        'jquery.ui.touch': {
            'deps': ['jquery', 'jquery.ui']
        },
        'utils.locale': {
            'deps': ['utils.string'],
            'exports': 'Locale'
        },
        'utils.time': {
            'deps': ['jquery', 'utils.locale'],
            'exports': 'Time'
        },
        'utils.date': {
            'deps': ['jquery', 'utils.locale']
        },
        'ofi': {
            'init': function () {
                objectFitImages();
            },
            'deps': ['jquery']
        },
        'google_adwords': {
            'exports': 'google_trackConversion'
        },
        'google_analytic': {
            'exports': 'ga'
        },
        'google_translate': {
            'exports': 'google_translate'
        },
        'line_liff': {
            'exports': 'liff'
        },
        'google_universal_analytic': {
            'exports': 'gtagCompany'
        },
        //'google.intl.phone' : ['jquery' ],
        'google.intl.phone.init' : ['jquery',/*'google.intl.phone'*/ ]
    },
    generateSourceMaps: true,
    preserveLicenseComments: false,
    urlArgs: 'bust=' + (new Date()).getTime() // to not cache
});

requirejs(['Application', 'Config'], function(Application, Config) {
    // to make it visible for old date/time/locale utils
    window.Config = Config;

    var dPaths = {};
    if (Config.getInstance().getPluginStatus('google_analytics')) {
        dPaths['google_universal_analytic'] = 'https://www.googletagmanager.com/gtag/js?id=' + Config.getInstance().getOption('company_ga_tracking_id');
    }

	requirejs.config({
		paths: _.extend({
			'ext': '/v2/themes/' + theme + '/js',
            'third-party-libs': '/v2/lib',
		}, dPaths)
	});

    var startApp = function (extPlugin) {
        var app = new Application({
            theme: theme,
            themeVars: themeVars,
            userThemeSettings: userThemeSettings,
            extPlugin: extPlugin
        });
        app.start();
    };
	requirejs(['ext/ExternalPluginsInitializer'], function(ExternalPluginsInitializer) {
        startApp(new ExternalPluginsInitializer());
	}, function () {
        startApp();
    });
});

define("../init", function(){});

